import LocomotiveScroll from 'locomotive-scroll';
import "locomotive-scroll/locomotive-scroll.css";

const Diferenciais = () => {
    const components = document.querySelectorAll('[data-component="diferenciais"]');
    const locomotiveScroll = new LocomotiveScroll();

    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    window.addEventListener('progressDiferenciais', (e) => {
        const { target, progress } = e.detail;

        if (isMobile) {
            // fundo 100% opaco no mobile
            target.style.opacity = 1;
            target.style.backgroundColor = `rgba(9, 30, 2, 1)`;
            return;
        }

        // comportamento normal no desktop
        target.style.opacity = progress;
        target.style.backgroundColor = `rgba(9, 30, 2, ${progress})`;
    });
};

export default Diferenciais;

if (document.querySelectorAll('[data-component="diferenciais"]')) {
    Diferenciais();
}
